
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexFln2Pk0qVAIcq2VdPCDNn1AhTixef0uE_A_xmwpy2zwMeta } from "/app/app/pages/(misc)/index.vue?macro=true";
import { default as indexrFliVMUeety8DnuqoGVTDvHhUKFmbazMw21YxlorfAEMeta } from "/app/app/pages/(app)/index/auth/index.vue?macro=true";
import { default as sign_45inCUUdn1uJAcUoHphNrxtk9YrJLntFTareqYJHXpFrMiAMeta } from "/app/app/pages/(app)/index/auth/sign-in.vue?macro=true";
import { default as sign_45up9BwoJj7Q47GTsnwRzH7eXsUsBmDdNPlp7oxqocvNOMMMeta } from "/app/app/pages/(app)/index/auth/sign-up.vue?macro=true";
import { default as recoveryENKu0b9ME_Nn_gEU15u9kYIbGgDxaS4ZDaSmxhL7negMeta } from "/app/app/pages/(app)/index/auth/recovery.vue?macro=true";
import { default as authx1JHefc91IIDMQJZhjefDBfB5FaKxCuocVfQIoUaSrwMeta } from "/app/app/pages/(app)/index/auth.vue?macro=true";
import { default as invitesxXDRweopsVA0thdJWJU4kH4LkJyLnwhC8s15J13DMEMeta } from "/app/app/pages/(app)/index/invite.vue?macro=true";
import { default as profileTzz9jgoXpiqsfZQ2BZqQNKTf6kgvio8gel_BsQxOogoMeta } from "/app/app/pages/(app)/index/profile.vue?macro=true";
import { default as indexWoFK69HZDrE4Iz1Mj3pNHWWcy0CPEuvukrIUOQPTcv0Meta } from "/app/app/pages/(app)/index/articles/index.vue?macro=true";
import { default as _91slug_93dgIqWjzlwG_ElwKKD1pUUWml9e_GMCGKniKXgOOiY48Meta } from "/app/app/pages/(app)/index/articles/[slug].vue?macro=true";
import { default as articles9KlfUqlVa_MUUeJRzv37MiEWnJXrRu1sl3b6A8rJ9CMMeta } from "/app/app/pages/(app)/index/articles.vue?macro=true";
import { default as dashboardkh9DT57aYX086_dOBUHfL5g0RAMQ9uszX_MscLxhi9EMeta } from "/app/app/pages/(app)/index/dashboard.vue?macro=true";
import { default as indexPA_qiOf8UXMmxraJUChEhnKQGOVmQiUdDf4wDvf8Cz4Meta } from "/app/app/pages/(app)/index/interests/index.vue?macro=true";
import { default as packsRbxqBNC4CgYbqFUW8Bi0PJHda_3xnW5es4oxNcQeOWgMeta } from "/app/app/pages/(app)/index/interests/packs.vue?macro=true";
import { default as changeBVv4lGwDrBRz_8RpxveX9JnC3Y_5aNTrTvMnHShOLPkMeta } from "/app/app/pages/(app)/index/interests/change.vue?macro=true";
import { default as archiveJY2GVePnrl_ygsHckqWRcBOa3mvn6c1mdF4dEaF24CQMeta } from "/app/app/pages/(app)/index/interests/results/archive.vue?macro=true";
import { default as compareANuZhTDN4jStgweS9X9Pffb3_qg_Z9DDhCrMDfScG4oMeta } from "/app/app/pages/(app)/index/interests/results/compare.vue?macro=true";
import { default as results_MISjmj9DCb2A2dhcQeEmeKw3p5lJ1kAcCtwH0kHa0sMeta } from "/app/app/pages/(app)/index/interests/results.vue?macro=true";
import { default as interests6BUhbTX6aAj7cWBHVH9kFz83oRstG_2jx3T92EG1_9sMeta } from "/app/app/pages/(app)/index/interests.vue?macro=true";
import { default as indexTJVpOHeXoWnB_fN_1HW7TrlHTQs8L8yJ6BiplIPgCM0Meta } from "/app/app/pages/(app)/index/game/index.vue?macro=true";
import { default as _91id_93cl5dxB3o0khxAQwi5mGdyPUf8qKdqirxjYsZ5NXn9qAMeta } from "/app/app/pages/(app)/index/tasks/[id].vue?macro=true";
import { default as indexHffdqRaxy6BaBWpfLaFl7U_brz8mE57qhTEQdVUQLB0Meta } from "/app/app/pages/(app)/index/tasks/custom/index.vue?macro=true";
import { default as createf02tcwTij_8d6JPYH8lxGrC5tBie5kCIGCn4_tA1s98Meta } from "/app/app/pages/(app)/index/tasks/custom/create.vue?macro=true";
import { default as _91taskId_93xvCGM9UN0WKyB2zp0FB_rOz4Ftto2pCxWGw0NHVr67UMeta } from "/app/app/pages/(app)/index/tasks/custom/[taskId].vue?macro=true";
import { default as customYP5a_kcA9wLN_iM0OUozU097N6YIOlLBRUBXqMqTlbEMeta } from "/app/app/pages/(app)/index/tasks/custom.vue?macro=true";
import { default as settings5eUpYHWzdTdJ4OQPM8ObNg9TY4ieKcfIWjEjJi2XAM0Meta } from "/app/app/pages/(app)/index/game/settings.vue?macro=true";
import { default as auth_45without_452fa7mFrTRGSZ3kPtxgDVOEkzBc6huX6o2XL2WzkwBR2rQMMeta } from "/app/app/pages/(app)/index/auth-without-2fa.vue?macro=true";
import { default as telegram_45paymentBRWYzI_XiqXZEjEVoDZnmMH_6PXj0mJ5HId2N7DL5JQMeta } from "/app/app/pages/(app)/index/telegram-payment.vue?macro=true";
import { default as email_45verificationlrijw6_4SF1WswszBDgBkyEqWfgnM19JFfYnAc7rShsMeta } from "/app/app/pages/(app)/index/email-verification.vue?macro=true";
import { default as indexU_ZYfLNAfMbDPN_XIGSDqSwXYfkMl8pwES0WIQWE_WIMeta } from "/app/app/pages/(app)/index.vue?macro=true";
import { default as about_45fantsgMqdxzycVpRp7p9SvXI3tbSTduzCSBnbML5wi7QjAdMMeta } from "/app/app/pages/(misc)/about-fants.vue?macro=true";
import { default as about_45interestssgzDamcCJrSLJQW6sTALGN4ZFUUIM7XlhtYWyWLaOIkMeta } from "/app/app/pages/(misc)/about-interests.vue?macro=true";
export default [
  {
    name: indexU_ZYfLNAfMbDPN_XIGSDqSwXYfkMl8pwES0WIQWE_WIMeta?.name,
    path: "/",
    component: () => import("/app/app/pages/(app)/index.vue"),
    children: [
  {
    name: "index",
    path: "",
    meta: indexFln2Pk0qVAIcq2VdPCDNn1AhTixef0uE_A_xmwpy2zwMeta || {},
    component: () => import("/app/app/pages/(misc)/index.vue")
  },
  {
    name: authx1JHefc91IIDMQJZhjefDBfB5FaKxCuocVfQIoUaSrwMeta?.name,
    path: "auth",
    component: () => import("/app/app/pages/(app)/index/auth.vue"),
    children: [
  {
    name: "index-auth",
    path: "",
    component: () => import("/app/app/pages/(app)/index/auth/index.vue")
  },
  {
    name: "index-auth-sign-in",
    path: "sign-in",
    component: () => import("/app/app/pages/(app)/index/auth/sign-in.vue")
  },
  {
    name: "index-auth-sign-up",
    path: "sign-up",
    component: () => import("/app/app/pages/(app)/index/auth/sign-up.vue")
  },
  {
    name: "index-auth-recovery",
    path: "recovery",
    component: () => import("/app/app/pages/(app)/index/auth/recovery.vue")
  }
]
  },
  {
    name: "index-invite",
    path: "invite",
    component: () => import("/app/app/pages/(app)/index/invite.vue")
  },
  {
    name: "index-profile",
    path: "profile",
    meta: { ...(profileTzz9jgoXpiqsfZQ2BZqQNKTf6kgvio8gel_BsQxOogoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/app/pages/(app)/index/profile.vue")
  },
  {
    name: articles9KlfUqlVa_MUUeJRzv37MiEWnJXrRu1sl3b6A8rJ9CMMeta?.name,
    path: "articles",
    component: () => import("/app/app/pages/(app)/index/articles.vue"),
    children: [
  {
    name: "index-articles",
    path: "",
    component: () => import("/app/app/pages/(app)/index/articles/index.vue")
  },
  {
    name: "index-articles-slug",
    path: ":slug()",
    component: () => import("/app/app/pages/(app)/index/articles/[slug].vue")
  }
]
  },
  {
    name: "index-dashboard",
    path: "dashboard",
    meta: { ...(dashboardkh9DT57aYX086_dOBUHfL5g0RAMQ9uszX_MscLxhi9EMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/app/pages/(app)/index/dashboard.vue")
  },
  {
    name: interests6BUhbTX6aAj7cWBHVH9kFz83oRstG_2jx3T92EG1_9sMeta?.name,
    path: "interests",
    meta: { ...(interests6BUhbTX6aAj7cWBHVH9kFz83oRstG_2jx3T92EG1_9sMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/app/pages/(app)/index/interests.vue"),
    children: [
  {
    name: "index-interests",
    path: "",
    component: () => import("/app/app/pages/(app)/index/interests/index.vue")
  },
  {
    name: "index-interests-packs",
    path: "packs",
    component: () => import("/app/app/pages/(app)/index/interests/packs.vue")
  },
  {
    name: "index-interests-change",
    path: "change",
    component: () => import("/app/app/pages/(app)/index/interests/change.vue")
  },
  {
    name: "index-interests-results",
    path: "results",
    component: () => import("/app/app/pages/(app)/index/interests/results.vue"),
    children: [
  {
    name: "index-interests-results-archive",
    path: "archive",
    component: () => import("/app/app/pages/(app)/index/interests/results/archive.vue")
  },
  {
    name: "index-interests-results-compare",
    path: "compare",
    component: () => import("/app/app/pages/(app)/index/interests/results/compare.vue")
  }
]
  }
]
  },
  {
    name: "index-game",
    path: "game",
    component: () => import("/app/app/pages/(app)/index/game/index.vue")
  },
  {
    name: "index-tasks-id",
    path: "tasks/:id()",
    component: () => import("/app/app/pages/(app)/index/tasks/[id].vue")
  },
  {
    name: customYP5a_kcA9wLN_iM0OUozU097N6YIOlLBRUBXqMqTlbEMeta?.name,
    path: "tasks/custom",
    meta: { ...(customYP5a_kcA9wLN_iM0OUozU097N6YIOlLBRUBXqMqTlbEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/app/pages/(app)/index/tasks/custom.vue"),
    children: [
  {
    name: "index-tasks-custom",
    path: "",
    component: () => import("/app/app/pages/(app)/index/tasks/custom/index.vue")
  },
  {
    name: "index-tasks-custom-create",
    path: "create",
    component: () => import("/app/app/pages/(app)/index/tasks/custom/create.vue")
  },
  {
    name: "index-tasks-custom-taskId",
    path: ":taskId()",
    component: () => import("/app/app/pages/(app)/index/tasks/custom/[taskId].vue")
  }
]
  },
  {
    name: "index-game-settings",
    path: "game/settings",
    component: () => import("/app/app/pages/(app)/index/game/settings.vue")
  },
  {
    name: "index-auth-without-2fa",
    path: "auth-without-2fa",
    component: () => import("/app/app/pages/(app)/index/auth-without-2fa.vue")
  },
  {
    name: "index-telegram-payment",
    path: "telegram-payment",
    component: () => import("/app/app/pages/(app)/index/telegram-payment.vue")
  },
  {
    name: "index-email-verification",
    path: "email-verification",
    component: () => import("/app/app/pages/(app)/index/email-verification.vue")
  }
]
  },
  {
    name: "about-fants",
    path: "/about-fants",
    meta: about_45fantsgMqdxzycVpRp7p9SvXI3tbSTduzCSBnbML5wi7QjAdMMeta || {},
    component: () => import("/app/app/pages/(misc)/about-fants.vue")
  },
  {
    name: "about-interests",
    path: "/about-interests",
    meta: about_45interestssgzDamcCJrSLJQW6sTALGN4ZFUUIM7XlhtYWyWLaOIkMeta || {},
    component: () => import("/app/app/pages/(misc)/about-interests.vue")
  }
]